import { create } from "zustand";
import { wsClient, type ConnectionStatus } from "../lib/ws-client";

interface ConnectionState {
  status: ConnectionStatus;
  disconnectReason: string | null;
  limitedMode: boolean;
  instanceId: string;
}

export const useConnectionStore = create<ConnectionState>()(() => ({
  status: wsClient.getStatus(),
  disconnectReason: wsClient.getDisconnectReason(),
  limitedMode: wsClient.limitedMode,
  instanceId: wsClient.instanceId,
}));

wsClient.onStatus((status) => {
  if (useConnectionStore.getState().status !== status) {
    useConnectionStore.setState({ status });
  }
});

wsClient.onForceDisconnect = () => {
  useConnectionStore.setState({
    disconnectReason: wsClient.getDisconnectReason(),
  });
};

wsClient.onPermissionsChanged = (limitedMode) => {
  useConnectionStore.setState({ limitedMode });
};
